import { Button, KIND, SHAPE, SIZE } from "baseui/button"
import { FormattedMessage } from "react-intl"
import { useSetObjectValue } from "../../../hooks/useSetObjectValue";

export  const AckButton = (props) => {
    const [ack, setAck] = useSetObjectValue(props.id, props.resourceGroupId, "ack", props.ack, 100);

    return (<Button isLoading={ack} onClick={() => { setAck(true) }} kind={ack ? KIND.primary : KIND.secondary} shape={SHAPE.pill} size={SIZE.compact} >
        <FormattedMessage id="Acknowledge.acknowledge" defaultMessage={'Acknowledge'}></FormattedMessage>
    </Button>)
}